// extracted by mini-css-extract-plugin
export var arrow = "index-module--arrow--ykjxj";
export var author = "index-module--author--26bk5";
export var caseDescription = "index-module--caseDescription--6WY9w";
export var caseTitle = "index-module--caseTitle--UrMNz";
export var company = "index-module--company--QKaTx";
export var container = "index-module--container--Wqim2";
export var gradBorder = "index-module--gradBorder--8R9Va";
export var header = "index-module--header--iiK8v";
export var quote = "index-module--quote--fRiic";
export var readMore = "index-module--readMore--561T7";
export var title = "index-module--title--b4Bx1";
export var topUseCase = "index-module--topUseCase--9qoac";
export var useCase = "index-module--useCase--77eGu";
export var useCases = "index-module--useCases--AyPcX";